/**
 * Possible sort columns for comment api
 * GET /comment/v1/comments?sortBy=
 */
const CommentSortColumn = {
    CREATED_AT: 'created_at',
    REACTIONS: 'reactions',
    REPLIES: 'replies'
};

/**
 * Possible sort directions for comment api
 * GET /comment/v1/comments?sortOrder=
 */
const CommentSortDirection = {
    ASC: 'asc',
    DESC: 'desc'
};

export {CommentSortColumn, CommentSortDirection};
